import InputMail from '@/components/InputMail'
import ButtonSubmit from '@/components/ButtonSubmit'
import validateEmail from '../../pure/validateEmail'
import connect from '@/connect'

export default
{
    components:
    {
        InputMail,
        ButtonSubmit
    },

    data()
    {
        return {
            emails: [''],
            errors: [''],
            error: '',
            message: null,
            isSubmitted: false
        }
    },

    computed:
    {
        mailsData()
        {
            return this.emails.map((email, id) => ({
                email,
                error: this.errors[id]
            }))
        }
    },

    methods:
    {
        addMore()
        {
            if (this.emails[this.emails.length - 1] === '')
            {
                this.$set(this.errors, this.errors.length - 1, 'Inform all email before add new')
            }
            else
            {
                this.emails.push('')
                this.errors.push('')
                this.error = ''
                this.$nextTick(() => this.$refs.emails[this.$refs.emails.length - 1].$el.querySelector('input').focus())
            }
        },

        updateMail(id, mail)
        {
            this.$set(this.emails, id, mail)
            this.$set(this.errors, id, '')
            this.error = ''
        },

        submit()
        {
            let totalErrors = 0
            this.emails.forEach((email, id) =>
            {
                const isValid = validateEmail(email)
                if (!isValid)
                {
                    this.$set(this.errors, id, 'Please send a valid email')
                    totalErrors++
                }
            })

            if (totalErrors < 1)
            {
                connect.requestToken(this.emails)
                    .then(data =>
                    {
                        if (data.success)
                        {
                            this.errors = this.errors.map(() => '')
                            this.error = ''
                            this.isSubmitted = true

                            return data
                        }
                        else
                        {
                            throw data.error
                        }
                    })
                    .catch(error =>
                    {
                        this.errors = this.errors.map(() => '')
                        this.error = error
                    })
            }
        }
    }
}
